module.exports = __webpack_public_path__ + "static/media/Roboto-MediumItalic.c16d19c2.ttf";